<template>
  <div class="gallery" v-if="images && images.length > 0">
    <a v-if="isBackButton" href="/" class="back-btn" aria-label="Start a new search">
      <svg class="ico">
        <use xlink:href="#ico-arr"/>
      </svg>
      <span class="text show">Start a new search</span>
    </a>
    <div class="swiper-gallery">
      <div class="swiper-button-next swiper-button-white" slot="button-next"/>
      <div class="swiper-button-prev swiper-button-white" slot="button-prev"/>
      <swiper :options="swiperOptionsMain" class="main-gallery" ref="swiperMain">
        <swiper-slide v-for="(image, index) in images">
          <button aria-label="Open gallery modal">
            <img width="100%" height="28.125rem" :src="image.hero" :key="index" :id="index" :alt="image.cap || 'hero image'"/>
          </button>
        </swiper-slide>
      </swiper>
      <swiper :options="swiperOptionsThumbs" class="gallery-thumbs" ref="swiperThumbs" @click="toggleSlide">
        <swiper-slide v-for="image in thumbImages">
          <img width="100%" height="220px" :src="image.normal" :alt="image.cap"/>
        </swiper-slide>
      </swiper>
    </div>
    <button @click="modalToggle(0)" class="btn-show-all" aria-label="Show all photos">
      <svg class="ico ico--20">
        <use xlink:href="#icon-dots"/>
      </svg>
      <span>Show all photos</span>
    </button>
    <div v-if="isModalVisible">
      <Modal :images="images"
             :activeSlide="activeSlide"
             :isModalVisible="isModalVisible"
             @toggleModal="modalToggle"
      />
    </div>
  </div>
  <div v-else class="gallery-placeholder">
    <a v-if="isBackButton" href="/" class="back-btn" aria-label="Start a new search">
      <svg class="ico">
        <use xlink:href="#ico-arr"/>
      </svg>
      <span class="text show">Start a new search</span>
    </a>
    <img src="../../assets/images/prop/image_placeholder.jpg" alt="Placeholder">
  </div>
</template>

<script>
import 'swiper/css/swiper.css';
import Modal from "./gallery_modal";
import { Swiper, SwiperSlide, directive } from 'vue-awesome-swiper';

export default {
  data: function () {
    const app = this;
    return {
      thumbImages: [],
      thumbsImages: this.images,
      swiperOptionsMain: {
        speed: 200,
        loop: true,
        slidesPerView: 1,
        allowTouchMove: true,
        on: {
          click: function (swiper) {
            app.$parent.toggleModal(parseInt(swiper.target.id))
          },
        },
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        },
        breakpoints: {
          1024: {
            allowTouchMove: false,
          },
        },
      },
      swiperOptionsThumbs: {
        loop: true,
        spaceBetween: 10,
        slidesPerView: 2,
        direction: 'vertical',
        allowTouchMove: false,
        slideToClickedSlide: false,
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        }
      }
    }
  },
  props: {
    images: Array,
    isDesktop: Boolean,
    isModalVisible: Boolean,
    activeSlide: Number,
    isBackButton: Boolean,
  },
  components: { Swiper, SwiperSlide, Modal },
  methods: {
    modalToggle(index) {
      this.$emit('toggleModal', index);
    },
    toggleSlide() {
      this.$refs.swiperMain.$swiper.slideNext();
      this.$refs.swiperThumbs.$swiper.slideNext();
    },
  },
  directives: {
    swiper: directive
  },
  beforeMount() {
    this.thumbImages = this.images.map((image) => {
      return {
        normal: image.normal,
        cap: image.cap || "thubnail image"
      }
    });

    this.thumbImages.push(this.thumbImages.shift());
  },
}
</script>

<style lang="scss">
@import 'app/assets/stylesheets/_vars.scss';

.gallery {
  position: relative;

  .btn-show-all {
    position: absolute;
    bottom: 1.25rem;
    right: 1.25rem;
    z-index: 1;
    display: flex;
    flex-direction: row;
    align-items: center;
    cursor: pointer;
    background: #F5F5F5;
    border-radius: .25rem;
    padding: .313rem .625rem;
    outline: none;

    span {
      display: block;
      font-size: .75rem;
      line-height: .938rem;
    }

    svg {
      height: .9rem;
      width: .9rem;
      margin-right: .625rem;
    }

    &:hover, &:active, &:focus {
      background-color: lighten(#F5F5F5, 10%);
    }
  }

  .back-btn {
    z-index: 3;
    position: absolute;
    height: 1.75rem;
    width: auto;
    top: 1.25rem;
    left: 1.25rem;
    background-color: $col_white;
    border-radius: 1rem;
    box-shadow: 0 0.125rem 0.25rem $col_oplightblack;
    vertical-align: top;
    transition: 0.3s ease-in;
    display: flex;
    cursor: pointer;
    justify-content: center;
    align-items: center;
    text-decoration: none;
    font-size: 0.833rem;

    &:hover {
      background: $col_primary;
      transition: 0.3s ease-out;

      .ico {
        transition: 0.3s ease-out;
        fill: $col_white;
      }

      .text {
        color: $col_white;
        transition: 0.3s ease-out;
      }
    }

    .ico {
      width: 2rem;
      height: 0.75rem;
      margin-left: -0.125rem;
      transform: rotate(180deg);
      transition: 0.3s ease-in;
    }

    .text {
      vertical-align: inherit;
      transition: 0.2s ease-in;
      max-width: 0;
      white-space: nowrap;
      overflow: hidden;
      line-height: 1rem;

      &.show {
        max-width: 100%;
        transition: 0.2s ease-out;
        padding-right: .75rem;
      }
    }
  }

  .swiper-gallery {
    .swiper-button-next, .swiper-button-prev {
      display: none;

      @media #{$desktop} {
        cursor: pointer;
        height: 2.5rem;
        width: 2.5rem;
        border-radius: 2rem;
        display: flex;
        justify-content: center;
        align-items: center;
        background: #ffffff7d;
        color: $col_darkgrey;
        transition: .3s;

        &:after {
          font-size: 1rem;
        }

        &:hover {
          transition: .3s;
          background: #efefefc4;
        }
      }
    }

    @media #{$desktop} {
      .swiper-button-next {
        right: calc(25% + 1.625rem);
      }

      .swiper-button-prev {
        left: 1rem;
        z-index: 2;

        &:after {
          margin-left: -4px;
        }
      }
    }

    .main-gallery {
      .swiper-slide {
        height: 75vw;
        max-height: 28.125rem;

        button {
          width: 100%;
          height: 100%;
          outline: none;
          cursor: pointer;

          img {
            width: 100%;
            height: 100%;
            object-fit: cover;

            &:hover {
              -webkit-filter: brightness(90%);
              -webkit-transition: all .3s ease;
              -moz-transition: all .3s ease;
              -o-transition: all .3s ease;
              -ms-transition: all .3s ease;
              transition: all .3s ease;
            }
          }
        }
      }

      @media #{$desktop} {
        width: 100%;
        border-radius: 0.25rem;

        .swiper-slide {
          height: 100%;

          button {
            cursor: pointer;

            img {
              width: 100%;
              height: 450px;
              object-fit: cover;

              &:hover {
                -webkit-filter: brightness(90%);
                -webkit-transition: all .3s ease;
                -moz-transition: all .3s ease;
                -o-transition: all .3s ease;
                -ms-transition: all .3s ease;
                transition: all .3s ease;
              }
            }
          }
        }
      }
    }

    .gallery-thumbs {
      display: none;

      @media #{$desktop} {
        width: 100%;
        display: block;

        .swiper-wrapper {
          .swiper-slide {
            img {
              width: 100%;
              height: 100%;
              cursor: pointer;
              object-fit: cover;
              border-radius: 0.25rem;

              &:hover {
                -webkit-filter: brightness(90%);
                -webkit-transition: all .3s ease;
                -moz-transition: all .3s ease;
                -o-transition: all .3s ease;
                -ms-transition: all .3s ease;
                transition: all .3s ease;
              }
            }
          }
        }
      }
    }

    button {
      outline: none;
    }

    @media #{$desktop} {
      padding: 0;
      display: grid;
      height: 450px;
      position: relative;
      grid-column-gap: 10px;
      margin-bottom: 1.25rem;
      grid-template-columns: 3fr 1fr;
    }
  }
}

.gallery-placeholder {
  width: 100%;
  height: 75vw;
  display: flex;
  align-items: center;
  border-radius: 0.25rem;
  justify-content: center;
  background: $col_offwhite;

  img {
    width: 100%;
    height: auto;
    margin: auto;
    display: block;
  }

  @media #{$desktop} {
    height: 28.125rem;
    margin-bottom: 1.25rem;

    img {
      width: auto;
      height: 100%;
      margin: 0 auto;
      display: block;
    }
  }
}
</style>